<footer class="site-footer">
  <div class="footer-brand">
    <a class="brand footer-logo" routerLink="/">
      <span class="brand-mark" aria-hidden="true"><i></i><i></i></span>
      <strong>{{ appName }}</strong>
    </a>
    <p>{{ copy().footerDescription }}</p>
  </div>
  <div>
    <h2>{{ copy().footerExplore }}</h2>
    <a routerLink="/">{{ copy().home }}</a>
    <a routerLink="/chat-with-strangers">{{ copy().randomChat }}</a>
    <a routerLink="/make-friends-online">{{ copy().interests }}</a>
    <a routerLink="/blog">{{ copy().blog }}</a>
    <a routerLink="/safety-tips">{{ copy().safetyLink }}</a>
  </div>
  <div>
    <h2>{{ copy().footerLegal }}</h2>
    <a routerLink="/privacy">Privacy policy</a>
    <a routerLink="/terms">Terms of service</a>
    <a routerLink="/community-guidelines">Community guidelines</a>
    <a routerLink="/contact">Contact</a>
  </div>
  <div class="footer-cta">
    <p>{{ copy().footerReady }}</p>
    <a class="primary-button" routerLink="/chat">Talk to strangers now </a>
  </div>
  <div class="footer-bottom">
    18+ only. Use {{ appName }} responsibly. <span>{{ appName }} © 2026</span>
  </div>
</footer>
